<fieldset>
  <legend *ngIf="label" class="text-sm font-medium text-gray-900 flex gap-2">
    <div class="flex gap-1">
      {{ label }}
      <span *ngIf="is_required" class="text-red-500">*</span>
    </div>
    <p *ngIf="sub_text" class="text-xs text-gray-500 mt-1 font-normal italic">{{ sub_text }}</p>
  </legend>
  <div [class.mt-4]="label" [ngClass]="{
      'space-y-[18px]': layout === 'vertical',
      'flex flex-wrap gap-5': layout === 'horizontal',
      'pointer-events-none opacity-50': disabled
    }">
    <label *ngFor="let option of options" class="relative flex items-center gap-2 cursor-pointer" (click)="select(option.value)">
      <!-- Hidden native radio for accessibility -->
      <input type="radio" [id]="unique_id + '_' + option.value" [name]="unique_id" [value]="option.value" [checked]="option.value === value" (change)="select(option.value)" class="sr-only" />

      <!-- Custom radio circle -->
      <div class="relative flex items-center justify-center flex-shrink-0 rounded-full border-[1.5px]"
        style="width: 18px; height: 18px; border-radius: 34px;"
        [style.border-color]="option.value === value ? '#3F41D1' : '#666666'">
        <div *ngIf="option.value === value"
          style="width: 8px; height: 8px; background: #3F41D1; border-radius: 17px;">
        </div>
      </div>

      <!-- Label -->
      <span style="font-size: 14px; line-height: 15px;"
        [style.font-weight]="option.value === value ? '500' : '400'"
        [style.color]="option.value === value ? '#3F41D1' : '#212121'">
        {{ option.label }}
      </span>
    </label>
  </div>

  <div *ngIf="control && control.errors && (control.dirty || control.touched)" class="text-red-500 text-sm mt-1">
    <p *ngIf="control.errors['required']">{{ label }} is required.</p>
  </div>
</fieldset>
